// extracted by mini-css-extract-plugin
export default {"wrapper":"Button_wrapper__-Ls0V","nextBtn":"Button_nextBtn__vFfVh","submitWidth":"Button_submitWidth__-V7AI","backBtn":"Button_backBtn__oevJ0","chevron":"Button_chevron__P8w5d"};